export default __webpack_public_path__ + "static/media/ic_non_product.7c9bd122.svg";